import { Fund } from 'funds-model';
import {ProductType, PRODUCTS} from 'cart-model';

interface Item {
  item_id: string;
  item_name: string;
  currency: string;
  item_brand?: string;
  item_category?: string;
  item_category2: string;
  item_category3: string;
  item_category4?: string;
  item_category5?: string;
  item_variant: string;
  item_list_name?: string;
  index?: number;
}

export function item(fund: Fund, productType: ProductType, index?: number, itemListName?: string): Item {
  const unitCategory: string = PRODUCTS[productType].unitCategory;
  return {
    item_id: fund.id.toString(),
    item_name: fund.name,
    currency: 'PLN',
    item_brand: fund.quotesForUnitCode[unitCategory] ? fund.quotesForUnitCode[unitCategory].value.toString() : undefined,
    item_category: fund.umbrella ? fund.umbrella.name : undefined,
    item_category2: fund.risk.value.toString(),
    item_category3: fund.fundType.name,
    item_category4: fund.analizyOnlineRating ? fund.analizyOnlineRating.toString() : undefined,
    item_category5: fund.costsForUnitCode[unitCategory] ? fund.costsForUnitCode[unitCategory].ongoingChargePercentage.toString() : undefined,
    item_variant: unitCategory,
    ...(index !== undefined ? {index: (index+1)} : {}),
    ...(itemListName ? {item_list_name: itemListName}: {}),
  };
}
